const states = {
    member_details: {
        is_socket_connected: false,
        active_agent: {},
        groups: [],
        active_group: {},
        canned_responses: [],
        agents: [],
        transfer_chat: {
            selected_group: "",
            agent_list: {}
        },
        tags: [],
        loaders: {
            agents_loading: false,
            agents_loaded: false,
            new_agent_adding: false,
            agent_profile_loading: false,
            agent_profile_loaded: false,
            groups_loading: false,
            groups_loaded: false,
            canned_responses_loading: false,
            canned_responses_loaded: true,
            tags_loading: false,
            tags_loaded: false,
            tag_updating: false,
        }
    }
};

export default states;



// WEBPACK FOOTER //
// ./src/data/redux/member_details/states.js